import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SpecType, SubType, Components, getCountryName, getCountryNames, sendRioEvent } from '@chegg/commerce-utils';
import { updatedZipcode, getAddressSuggestionsSuccess, setDefaultCountry } from '../../redux/UserAddressState/UserAddressState.slice';
import { isZipMandatory, isCountryWithNoZipcode } from '../../utils/ZipUtil';
import { fireCallbackLoggingEvent } from '../../utils/CallbackUtil';
import { dropdownBlur, zipCodeRioEvent, handleCountrySelection, getCountryValidationText } from './helpers';
import { strings } from '../../constants/strings';
import AutocompleteDropdownWrapper from '../../internal/AutocompleteWrapper/AutocompleteWrapper';
import ZipcodeField from '../../internal/ZipcodeField';
var UserAddressWrapper = function UserAddressWrapper() {
  var _localizedCountryFiel;
  var _useSelector = useSelector(function (state) {
      return {
        config: state.config,
        userAddress: state.userAddress
      };
    }),
    config = _useSelector.config,
    userAddress = _useSelector.userAddress;
  var verifyAddress = config.verifyAddress,
    defaultCountryCode = config.defaultCountryCode,
    rioNamespace = config.rioNamespace,
    localizedCountryField = config.localizedCountryField,
    isUpi = config.isUpi,
    inputDisabled = config.inputDisabled;
  var country = userAddress.country,
    zip = userAddress.zip;
  var countryError = userAddress.country.error;
  var dispatch = useDispatch();
  var countryName = country.countryName,
    countryCode = country.countryCode;
  var zipCode = verifyAddress.zipCode,
    countryISO = verifyAddress.countryISO,
    city = verifyAddress.city,
    state = verifyAddress.state;
  var hide = zip.hide;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    initialized = _useState2[0],
    setInitialized = _useState2[1];
  var countrySelectDisabled = !!isUpi;
  useEffect(function () {
    if (!initialized) {
      dispatch(setDefaultCountry({
        defaultCountryCode: defaultCountryCode,
        localizedCountryList: localizedCountryField === null || localizedCountryField === void 0 ? void 0 : localizedCountryField.value
      }));
      dispatch(updatedZipcode({
        isMandatory: isZipMandatory(defaultCountryCode)
      }));
      setInitialized(true);
      sendRioEvent({
        info: Components.USER_ADDRESS,
        specType: SpecType.COMPONENT_VIEW,
        subType: SubType.COMPONENT,
        callback: function callback(logObj) {
          return fireCallbackLoggingEvent(logObj);
        },
        namespace: rioNamespace,
        force: false
      });
      if (!defaultCountryCode && !countryISO) {
        // log zipcode field hidden
        zipCodeRioEvent({
          isHidden: true,
          isMandatory: false,
          rioNamespace: rioNamespace
        });
      }
      // Case when there is a default country code but not countryISO. The shown log in dropDownChange
      // handler won't fire.
      if (!hide && defaultCountryCode && !countryISO && !isCountryWithNoZipcode(defaultCountryCode)) {
        var isMandatory = isZipMandatory(defaultCountryCode);
        // log zipcode field shown with mandatory or optional
        zipCodeRioEvent({
          isHidden: false,
          isMandatory: isMandatory,
          rioNamespace: rioNamespace
        });
      }
    }
  }, [initialized]);
  useEffect(function () {
    dispatch(updatedZipcode({
      value: zipCode,
      error: '',
      invalid: '',
      focused: false
    }));
    if (countryISO) {
      var name = getCountryName(countryISO);
      handleCountrySelection({
        countryName: name,
        dispatch: dispatch,
        city: city,
        state: state,
        isHydratingNewAddress: true,
        countryISO: countryISO,
        rioNamespace: rioNamespace,
        localizedCountryList: localizedCountryField === null || localizedCountryField === void 0 ? void 0 : localizedCountryField.value
      });
      // TODO (jcheung) investigate ... this doesn't look like it's doing anything
      updatedZipcode({
        isMandatory: isZipMandatory(countryCode)
      });
    }
    if (city && state) {
      dispatch(getAddressSuggestionsSuccess({
        success: true,
        zipcode: zipCode,
        city_states: [{
          city: city,
          state: state
        }],
        matches: 1
      }));
    }
  }, [zipCode, countryISO, city, state]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hide && /*#__PURE__*/React.createElement(ZipcodeField, null), /*#__PURE__*/React.createElement(AutocompleteDropdownWrapper, {
    disabled: inputDisabled || countrySelectDisabled,
    labelText: (localizedCountryField === null || localizedCountryField === void 0 ? void 0 : localizedCountryField.labelText) || strings['APP.FROM.COUNTRY.LABEL'],
    value: countryName,
    icon: countryCode,
    error: getCountryValidationText(countryError, localizedCountryField),
    localizedCountryList: getCountryNames((_localizedCountryFiel = localizedCountryField === null || localizedCountryField === void 0 ? void 0 : localizedCountryField.value) !== null && _localizedCountryFiel !== void 0 ? _localizedCountryFiel : []),
    placeholder: (localizedCountryField === null || localizedCountryField === void 0 ? void 0 : localizedCountryField.placeHolderText) || strings['APP.FORM.COUNTRY.PLACEHOLDER'],
    onDropdownBlur: function onDropdownBlur(error, countryInput) {
      var _localizedCountryFiel2;
      return dropdownBlur({
        countryInput: countryInput,
        localizedCountryList: (_localizedCountryFiel2 = localizedCountryField === null || localizedCountryField === void 0 ? void 0 : localizedCountryField.value) !== null && _localizedCountryFiel2 !== void 0 ? _localizedCountryFiel2 : [],
        city: city,
        state: state,
        error: error,
        dispatch: dispatch
      });
    },
    onDropdownChange: function onDropdownChange(changeValue) {
      var _localizedCountryFiel3;
      return handleCountrySelection({
        countryName: changeValue,
        dispatch: dispatch,
        city: city,
        state: state,
        isHydratingNewAddress: false,
        rioNamespace: rioNamespace,
        localizedCountryList: (_localizedCountryFiel3 = localizedCountryField === null || localizedCountryField === void 0 ? void 0 : localizedCountryField.value) !== null && _localizedCountryFiel3 !== void 0 ? _localizedCountryFiel3 : []
      });
    }
  }));
};
export default UserAddressWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/views/UserAddressWrapper/UserAddressWrapper.js
// module id = 4502
// module chunks = 11